"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInsuranceCoverage = void 0;
const binder_1 = __importDefault(require("../../binder"));
const insuranceCoverage_class_1 = __importDefault(require("./insuranceCoverage.class"));
const insuranceLicense_1 = __importDefault(require("../../licensing/insuranceLicense"));
const getInsuranceCoverage = (data) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (data.version >= 5) {
        return insuranceCoverage_class_1.default.fromObj(data.coverage);
    }
    const insuranceLicenses = [];
    if ((_a = data.partner) === null || _a === void 0 ? void 0 : _a.insuranceLicense) {
        insuranceLicenses.push(insuranceLicense_1.default.fromObj(data.partner.insuranceLicense));
    }
    return insuranceCoverage_class_1.default.fromObj(Object.assign({ coverageId: "loadsure", tax: (_b = data.insuranceProduct) === null || _b === void 0 ? void 0 : _b.taxAmount, binder: binder_1.default.fromLegacyArgoBinder((_c = data.binder) !== null && _c !== void 0 ? _c : {}), insuranceLicenses, address: (_g = (_e = (_d = data.partner) === null || _d === void 0 ? void 0 : _d.insuranceLicense) !== null && _e !== void 0 ? _e : (_f = data.partner) === null || _f === void 0 ? void 0 : _f.taxes) !== null && _g !== void 0 ? _g : {} }, ((_h = data.coverage) !== null && _h !== void 0 ? _h : data.insuranceProduct)));
};
exports.getInsuranceCoverage = getInsuranceCoverage;
exports.default = insuranceCoverage_class_1.default;
//# sourceMappingURL=index.js.map